/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from "@tanstack/react-query";
import { authService } from "@/api/services/auth.service";
import { saveToken, saveRefreshToken, clearAllTokens } from "@/utils/storage";

export const useLogin = () => {
  return useMutation({
    mutationFn: authService.login,
    onSuccess: (data: any) => {
      saveToken(data.accessToken);
      if (data.refreshToken) saveRefreshToken(data.refreshToken);
      window.location.href = "/";
    },
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: authService.logout,
    onSettled: () => {
      clearAllTokens();
      window.location.href = "/login";
    },
  });
};
